module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-200-light-italic-6f9c97392505430d6a646c637178b1f6.woff2";